<template>
  <div class="notifications-changed-images">
    <h4 class="notifications-changed-images__title">{{ title }}</h4>
    <div class="notifications-changed-images__list">
      <img
        v-for="(item, index) in list"
        :key="index"
        :src="`${item.image}?token=${ACCESS_TOKEN}`"
        alt="changed photo"
        class="notifications-changed-images__image"
      />
    </div>
  </div>
</template>

<script>
import { loadStorageItem } from '@/services/storage'

const STATUS_ADDED = 'added'
const STATUS_DELETED = 'deleted'

export default {
  name: 'NotificationsChangedImages',
  props: {
    action: {
      type: String,
      required: true,
      validator: val => [STATUS_ADDED, STATUS_DELETED].includes(val)
    },
    list: { type: Array, required: true }
  },
  data() {
    return {
      ACCESS_TOKEN: loadStorageItem('accessToken')
    }
  },
  computed: {
    title() {
      const isDeletion = this.action === STATUS_DELETED
      return `БЫЛИ ${isDeletion ? 'УДАЛЕНЫ' : 'ДОБАВЛЕНЫ'} ФОТОГРАФИИ (${this.list.length})`
    }
  }
}
</script>
